var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakePosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2263_5838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1036 7.25C10.1036 6.97386 9.87971 6.75 9.60356 6.75H2.60454C2.3284 6.75 2.10454 6.97386 2.10454 7.25V8.75C2.10454 9.02614 2.3284 9.25 2.60454 9.25H9.60356C9.87971 9.25 10.1036 9.02614 10.1036 8.75V7.25Z",
    stroke: "#CBD0E0",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1036 12.25C10.1036 11.9739 9.87971 11.75 9.60356 11.75H2.60454C2.3284 11.75 2.10454 11.9739 2.10454 12.25V13.75C2.10454 14.0261 2.3284 14.25 2.60454 14.25H9.60356C9.87971 14.25 10.1036 14.0261 10.1036 13.75V12.25Z",
    stroke: "#CBD0E0",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8989 2.25C14.8989 1.97386 14.6751 1.75 14.3989 1.75H7.39893C7.12278 1.75 6.89893 1.97386 6.89893 2.25V3.75C6.89893 4.02614 7.12278 4.25 7.39893 4.25H14.3989C14.6751 4.25 14.8989 4.02614 14.8989 3.75V2.25Z",
    stroke: "#CBD0E0",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2263_5838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakePosition);
export default __webpack_public_path__ + "static/media/makePosition.473cea8475cd7de8b73d5d5464073303.svg";
export { ForwardRef as ReactComponent };